<template>
  <div class="files">
    <Head title="Formulare & Regelemente" />

    <div class="col-two">
      <div class="col-two--left">



       <textblock :textblocks="textblocks" :auth="auth" :textid="3"></textblock>

        <div class="files-wrapper">

          <div class="col-3">
            <h3>Dokumente</h3>
            <draggable
              class="list-group"
              :list="files[2]"
            :group="{ name: 'myGroup', pull: 'clone', put: true }"
              @change="saveorder"
              item-key="id"
            >
              <template #item="{ element, index }">
                <div v-bind:class="['is-'+element.extension,'file-row',{'editmode':element.editable}]">
                  <div>
                      <input v-if="element.editable" v-model="element.name" type="text"  />
                      <span v-else>
                        <a :href="element.path">
                          {{ element.name }}
                        </a>
                      </span>
                  </div>
                  <div v-if="auth.user.owner">
                    <span v-if="element.editable" @click="save(element)" >save</span>
                    <span v-else>
                      <i @click="edit(element)" > <img @click="editmode = 1;" v-if="!editmode" style="cursor:pointer;width:15px;display:inline-block;margin-right:4px; height:auto;" src="/img/icons/edit.png" /></i>
                      <i @click="remove(element)" style="color:#ff0000">x</i>
                    </span>
                  </div>
                </div>
              </template>
            </draggable>
          </div>

          <div class="col-3">
            <h3>Pläne</h3>
            <draggable
              class="list-group"
              :list="files[1]"
            :group="{ name: 'myGroup', pull: 'clone', put: true }"
              @change="saveorder"
              item-key="id"
            >
              <template #item="{ element, index }">
                <div v-bind:class="['is-'+element.extension,'file-row',{'editmode':element.editable}]">
                  <div>
                      <input v-if="element.editable" v-model="element.name" type="text"  />
                      <span v-else>
                        <a :href="element.path">
                        {{ element.name }}
                        </a>
                      </span>
                  </div>
                  <div v-if="auth.user.owner">
                    <span v-if="element.editable" @click="save(element)" >save</span>
                    <span v-else>
                      <i @click="edit(element)" >    <img @click="editmode = 1;" v-if="!editmode" style="cursor:pointer;width:15px;display:inline-block;margin-right:4px; height:auto;" src="/img/icons/edit.png" /></i>
                      <i @click="remove(element)" style="color:#ff0000">x</i>
                    </span>
                  </div>
                </div>
              </template>
            </draggable>
          </div>

        </div>

         <div class="col-3" v-if="auth.user.owner">
           <br><br>
          <h3>nicht zugeordnet</h3>
          <draggable
            class="list-group"
            :list="files[0]"
            :group="{ name: 'myGroup', pull: 'clone', put: false }"
            @change="saveorder"
            item-key="id"
          >
            <template #item="{ element, index }">
              <div v-bind:class="['is-'+element.extension,'file-row',{'editmode':element.editable}]">
                <div>
                    <input v-if="element.editable" v-model="element.name" type="text"  />
                    <span v-else>
                      <a :href="element.path">
                        {{ element.name }}
                      </a>
                    </span>
                </div>

                <div v-if="auth.user.owner">
                  <span v-if="element.editable" @click="save(element)" >save</span>
                  <span v-else>
                    <i @click="edit(element)" >    <img @click="editmode = 1;" v-if="!editmode" style="cursor:pointer;width:15px;display:inline-block;margin-right:4px; height:auto;" src="/img/icons/edit.png" />
</i>
                    <i @click="remove(element)" style="color:#ff0000">x</i>
                  </span>
                </div>
              </div>
            </template>
          </draggable>
        </div>

      </div>
      <div class="col-two--right">
          <div class="weather">
            <a class="weatherwidget-io" href="https://forecast7.com/de/47d508d72/winterthur/" data-label_1="WINTERTHUR" data-label_2="Wetter" data-font="Open Sans" data-days="3" data-theme="pure" >WINTERTHUR Wetter</a>
          </div>
          <div class="today"><span><label>{{ weekday }}</label><i>{{ date }}</i></span></div>
          <div class="calendar-teaser">
            <vue-cal
              ref="vuecal"
              locale="de"
              hide-view-selector
              :disable-views="['years', 'year', 'year','week','day']"
              active-view="month"
              :time-from="7 * 60" :time-to="22 * 60"
              :events="events"
              :on-event-click="onEventClick">
            </vue-cal>
          </div>
      </div>
    </div>

     <form v-if="auth.user.owner" @submit.prevent="upload" enctype='multipart/form-data' >
      <input type="file" multiple="multiple"  @input="form.file = $event.target.files" />
      <progress v-if="form.progress" :value="form.progress.percentage" max="100">
        {{ form.progress.percentage }}%
      </progress>
      <button type="submit">Submit</button>
    </form>

  </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import { useForm } from '@inertiajs/inertia-vue3'

import Textblock from '@/Shared/Textblock'

import draggable from 'vuedraggable'

import VueCal from 'vue-cal'
import 'vue-cal/dist/i18n/de.js'
import 'vue-cal/dist/vuecal.css'


import $ from "jquery";


!function(d,s,id){var js,fjs=d.getElementsByTagName(s)[0];if(!d.getElementById(id)){js=d.createElement(s);js.id=id;js.src='https://weatherwidget.io/js/widget.min.js';fjs.parentNode.insertBefore(js,fjs);}}(document,'script','weatherwidget-io-js');


export default {
  components: {
    Head,
    useForm,
    draggable,
    VueCal,
    Textblock,
    $
  },
  layout: Layout,
  data: function () {
    return {
      form: {
        file: null
      },
      drag: false,
      date: null,
      weekday: null,
    }
  },
  props: {
    files: Object,
    categories: Object,
    auth: Object,
    events: Object,
    locations: Object,
    textblocks: Object,
  },



   mounted() {
    this.$parent.bgimage = "/img/tower4.jpg";
    let app = this;
    let weekdays = ["Montag","Dienstag","Mittwoch","Donnerstag","Freitag","Samstag","Sonntag"];
    const today = new Date();
    const day = today.getDay();
    app.date = today.getDate();
    app.weekday = weekdays[day];
    setTimeout(function() {
       app.textblock = app.textblocks.find(x => x.id === 3);
    }, 5);



  },

  methods: {
    upload() {
       this.$inertia.visit('/upload', {
         method: 'post',
         data: this.form,
         forceFormData: true,
       });
    },
    edit(el) {
      for (let i = 0; i < this.files.length; ++i) {
          this.files[i].editable = false;
      }
      el.editable = true;
    },
    save(file) {
       this.$inertia.visit('/files/update', {
         method: 'post',
         data: { file: file},
       });
    },
    saveorder(e){
      let app = this;
      this.$inertia.post('/files/setorder', { files: app.files}, {method: 'post'})
    },
    remove(el){
      let app = this;
      this.$inertia.visit('/files/remove/'+el.id, {
        method: 'get',
      });
    },


  }


}
</script>
